import request from '@/utils/request'
import type { BillListParams, BillListResponse } from '@/types/bill'

/**
 * 获取账单列表
 */
export const getBillInfoList = (data: BillListParams) => {
  return request.post<BillListResponse>('/commonfacade/bill/getBillInfoList', data)
}

/**
 * 批量删除账单
 */
export const batchDeleteBill = (billIds: string[]) => {
  return request.post<{ status: number; data: boolean; message: string }>('/commonfacade/bill/batchDelete', { billIds })
}

